module.exports = __webpack_public_path__ + "img/zxes.bbf0603f.png";